import {expectEither, HttpClient, useHttpClient} from '@raison/network-facade';
import {queryOptions} from '@tanstack/react-query';
import {Document} from '../model/document';

const DocumentsResponse = Document.array();

function fetchDocuments(http: HttpClient) {
    return http('v1/investment-management/documents').then(
        ...expectEither({
            200: DocumentsResponse,
        })
    );
}

export function useDocumentsOptions() {
    const http = useHttpClient();
    return queryOptions({
        queryKey: ['v1/investment-management/documents'],
        queryFn: async ({queryKey, client}) => {
            const response = await fetchDocuments(http);
            if (response.status === 'Abort') {
                client.cancelQueries({queryKey});
                throw response.reason;
            }
            return response.json;
        },
    });
}
